import { pages } from "@microsoft/teams-js";
import { getStripeCheckoutUrl } from "@teams/client-shared";
import { useCallback } from "react";

import { useTeamsContext } from "../state/TeamsContextProvider";
import { getAppId, getPageContext } from "../utils/teamsHelpers";

export const usePaymentRedirect = () => {
  const { teamsContext } = useTeamsContext();
  const generatePaymentLink = useCallback(
    async (trackingSource: string, isTrial?: boolean, promoCode?: string) => {
      let referrer: string | undefined;

      if (teamsContext.page.frameContext === "content") {
        const tabInstances = await pages.tabs.getTabInstances();
        try {
          const botId = getAppId();
          const channelId = teamsContext?.channel?.id;
          const currentTab = tabInstances.teamTabs.find(tab => {
            return tab.channelId === channelId;
          });
          if (!currentTab) {
            referrer = undefined;
          } else {
            const entityId = currentTab.entityId;

            const webUrl = currentTab.url ?? "";
            const encodedWebUrl = webUrl;
            const encodedContext = `{"channelId": "${channelId}"}`;
            const taskItemUrl = `https://teams.microsoft.com/l/entity/${botId}/${entityId}?webUrl=${encodedWebUrl}&context=${encodedContext}`;

            referrer = taskItemUrl;
          }
        } catch (error) {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          referrer = undefined;
        }
      }

      const checkoutPath = getStripeCheckoutUrl(
        getPageContext() === "/agile" ? "agile" : "msteams",
        trackingSource,
        isTrial,
        referrer,
        promoCode
      );

      return `${window.location.origin}${checkoutPath}`;
    },
    [teamsContext.channel?.id, teamsContext.page.frameContext]
  );

  const openPaymentPage = useCallback(
    async (trackingSource: string, trial?: boolean, promoCode?: string) => {
      const link = await generatePaymentLink(trackingSource, trial, promoCode);
      window.open(link, "_blank");
    },
    [generatePaymentLink]
  );

  return { openPaymentPage, generatePaymentLink };
};
